'use client';

import { useTranslations } from 'next-intl';
import React from 'react';
import { MOBILE_APP_LINK } from '@/_components/mobile-app/_constants';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { Button } from '@/_kit/button';
import { EButtonColor, EButtonSize } from '@/_kit/button/_types';
import { ETextSize } from '@/_kit/text/_types';
import { Text } from '@/_kit/text';

type TProps = {
  text: string;
};

export const DownloadButton = ({ text }: TProps) => {
  const translations = useTranslations();

  const sendEvent = useAnalytics();

  const handleClick = () => {
    sendEvent({
      name: EAnalytics.SUPPLIER_LANDING_WB_PARTNERS_T,
    });

    window.open(MOBILE_APP_LINK);
  };

  return (
    <Button
      backgroundColor={EButtonColor.WHITE}
      onClick={handleClick}
      size={EButtonSize.MEDIUM}
      strokeColor={EButtonColor.BLACK}
    >
      <Text size={ETextSize.SMALL} text={translations(text)} variant="body" />
    </Button>
  );
};
